import withIcon from './NewIcon';
// @ts-ignore
import IconDiscount from './icon/xl/discount.s.svg';

export default withIcon(IconDiscount);
